import { DRNUtil } from '@traveloka/district-util';
import { Dimensions } from 'react-native';
export function getNotificationBannerStyle(state, translateX) {
    return {
        padding: 20,
        // @ts-ignore
        position: DRNUtil.isWeb() ? 'fixed' : 'absolute',
        top: state.position === 'TOP_LEFT' || state.position === 'TOP_RIGHT' || state.position === 'TOP_CENTER'
            ? 20
            : undefined,
        left: state.position === 'TOP_LEFT' || state.position === 'BOTTOM_LEFT'
            ? 20
            : state.position === 'TOP_CENTER' || state.position === 'BOTTOM_CENTER'
                ? Dimensions.get('window').width / 2
                : undefined,
        right: state.position === 'TOP_RIGHT' || state.position === 'BOTTOM_RIGHT' ? 20 : undefined,
        bottom: state.position === 'BOTTOM_LEFT' || state.position === 'BOTTOM_RIGHT' || state.position === 'BOTTOM_CENTER'
            ? 20
            : undefined,
        transform: state.position === 'TOP_CENTER' || state.position === 'BOTTOM_CENTER' ? [{ translateX }] : undefined,
        alignSelf: 'flex-start',
        ...(DRNUtil.isWeb() ? { zIndex: 10000 } : {}),
    };
}
